
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Order } from '@/models/order';

import { APP_CONFIG } from '@/config/app-config';

import orderServices from '@/services/order-service';
import authService from '@/services/auth-services';
import u from '@/utility/utility';
import ConfirmModal from '@/shared/components/ConfirmModal.vue';
import formatNumber from '@/shared/filters/format-number';

@Component({
    components: {
        ConfirmModal
    }
})
export default class ListOrder extends Vue {
    private eventEmit = {
        eventReloadOrder: 'eventReloadOrder',
        eventCheckAll: 'eventCheckAll'
    };

    private actions = {
        cancel: 'cancel',
        deposit: 'deposit',
        complain: 'complain'
    };
    private actionSelected: any = this.actions.cancel;

    private isCheckAll = false;

    @Prop({ default: [] })
    private listOrder!: Order[];

    @Prop({ default: {} })
    private customerInfo: any;

    private selectedOrder!: Order;
    private showNextConfirm = true;
    private isConfirm = false;
    private isLoading = false;
    private modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    @Watch('listOrder', { immediate: true, deep: true })
    private async watchListOrder() {
        const totalChecked = this.listOrder.filter(x => x.isChecked === true).length;
        const totalAllowCheck = this.listOrder.filter(x => x.status === 0 || x.status === 3).length;

        this.isCheckAll = totalChecked === totalAllowCheck && totalAllowCheck > 0 ? true : false;
    }

    private async onCancelOrder() {
        this.isLoading = true;
        const dataRequest = {
            Status: 1
        };
        const result = await orderServices.updateOrder(this.selectedOrder.id, dataRequest);

        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Hủy đơn hàng thành công!',
            });

            this.$emit(this.eventEmit.eventReloadOrder);
            this.isLoading = false;
        }
    }

    private async onDepositOrder() {
        if (this.customerInfo.Wallet >= this.selectedOrder.minDeposit) {
            const dataRequest = {
                Status: 2,
                Deposit: this.selectedOrder.minDeposit
            };

            const result = await orderServices.updateOrder(this.selectedOrder.id, dataRequest);
            if (result && result.status === 200 && result.data.status === 200) {
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thông báo!',
                    text: 'Đặt cọc thành công!',
                });
                this.$emit(this.eventEmit.eventReloadOrder);

                this.getCustomersInfo();
            }
        } else {
            this.modalContent = '<div style="color: #111;">Số tiền trong ví của bạn không đủ để đặt cọc.</div><div class="text-danger">Hãy nạp tiền để tiếp tục đặt cọc!</div>';
            this.isConfirm = true;
            this.showNextConfirm = false;
        }
    }

    private async onActionStatus(order: Order, action: any) {
        this.actionSelected = action;
        this.selectedOrder = order;
        this.isConfirm = true;

        switch (this.actionSelected) {
            case this.actions.cancel: {
                this.modalContent = 'Bạn có thực sự muốn hủy đơn hàng này không?';
                this.isConfirm = true;
                this.showNextConfirm = true;
                break;
            }
            case this.actions.deposit: {
                this.modalContent = `<div style="color: #111">Số tiền bạn cần đặt cọc là <label class="fb text-danger">${formatNumber(this.selectedOrder.minDeposit, '0,0')} vnd.</label>
                                    <div>Bạn có muốn đặt cọc không?</div></div>`;
                this.isConfirm = true;
                this.showNextConfirm = true;
                break;
            }
        }
    }

    private onCloseModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
    }

    private onAcceptModal(eventData: any) {
        this.isConfirm = !eventData.close || false;
        if (eventData.data === 'OK' && this.actionSelected === this.actions.cancel) {
            this.onCancelOrder();
        } else if (eventData.data === 'OK' && this.actionSelected === this.actions.deposit) {
            this.onDepositOrder();
        }
    }

    private async getCustomersInfo() {
        if (this.userInfo.userId > 0) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if (result && result.status === 200) {
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
            }
        }
    }

    private async viewOrder(order: Order) {
        const routeData = this.$router.resolve({ name: 'order-detail', params: { orderId: order.id.toString() } });
        window.open(routeData.href, '_blank');
    }

    private async onCheckAllOrder() {
        this.$emit(this.eventEmit.eventCheckAll, this.isCheckAll);
    }

    protected proxyImage(src: string): string {
        return u.proxyImage(src);
    }
}
